<template>
    <tr>
        <td>
            {{ referral.index + 1 }}
        </td>
        <td class="py-3 text-center">
            {{referral.authorEmail}}
        </td>
        <td style="max-width: 400px">
            <div>
                <p>
                    {{ referral.refLink }}
                </p>
                <button id="copy" @click="copyTextToClipboard(referral.refLink)">
                    <span v-if="copied">copied</span>
                    <span v-else>copy</span>
                </button>
            </div>
        </td>
        <td class="text-center py-3">
            <p v-for="(item, index) in referral.to.filter((item, index) => referral.to.indexOf(item) === index)" :key="`${item}-${index}`">
                {{item}}
            </p>
        </td>
        <td class="py-3">
            {{ referral.to.filter((item, index) => referral.to.indexOf(item) === index).length }}
        </td>
    </tr>
</template>

<script>
export default {
    props: [
        'referral'
    ],
    data() {
        return {
            copied: false
        }
    },
    methods: {
        copyTextToClipboard: function(text) {
            let el = document.createElement('input')  
            el.value = text
            document.body.appendChild(el)
            el.select()
            el.focus()
            document.execCommand('copy')
            document.body.removeChild(el)
            this.copied = true  
            setTimeout(() => {
                this.copied = false 
            }, 2000)
        }
    }
}
</script>
<style lang="scss" scoped>
td {
    div {
        display: flex;
        justify-content: space-between;
        button#copy {
            background: #0ACF97;
            color: #ffffff;
            font-size: 11px;
            font-weight: bold;

            &.copied {

            }
        }
    }

}
</style>